import { Root, TabsWrapper } from 'components/_Navbar/index.styled';
import NavigationTabs from 'components/_Navbar/NavigationTabs';
import User from 'components/_Navbar/User';

const Navbar = () => (
  <Root>
    <User />
    <TabsWrapper>
      <NavigationTabs />
    </TabsWrapper>
  </Root>
);

export default Navbar;
